import formatPropertyName from "utils/column/formatPropertyName";
import getColumnLabelWithContext, {
  getCompactFieldDisplayTitle
} from "utils/column/getColumnLabelWithContext";

import { IGroupByListColumn } from "models";
import { EntityKind } from "models/entityKind";

interface GetColumnNameOptions {
  property: string;
  isFacility: boolean;
  facilityColumns: IGroupByListColumn[];
  columns: IGroupByListColumn[];
}

export const getColumnName = ({
  property,
  isFacility,
  facilityColumns,
  columns
}: GetColumnNameOptions) => {
  const propertyName = formatPropertyName(property);
  const columnsToUse = isFacility ? facilityColumns : columns;
  const column = columnsToUse.find((c) => propertyName === c.property);
  const entityKind = isFacility ? EntityKind.Facility : EntityKind.Well;
  if (!column) return propertyName;

  // entityKind goes in the 6th slot; the 5th is selectedForecastFolder. Passing
  // it one slot early was inert (only lightContextTitle is read below, and that
  // variant never touches selectedForecastFolder). `undefined` is NOT a safe
  // slot value either, so this is narrowed rather than defused: the Forecast
  // branch of fullContextTitle guards `!== ""` but not nullish, so it renders
  // a literal "(undefined)". Measured on a Forecast-group column - before:
  // "Oil + Cond: Twelve Month Cum (Mbbl) (Well)", after: "... (undefined)";
  // lightContextTitle is "Twelve Month Cum (Mbbl)" either way, which is why
  // all three call sites stay inert. Fix that guard before any caller here
  // switches to fullContextTitle.
  const title = getColumnLabelWithContext(
    column,
    false,
    null,
    false,
    undefined,
    entityKind
  );
  // Shared with the tooltip-defaults preview (DefaultMapTooltipFieldSetting)
  // so the preview shows this exact label rather than deriving its own.
  return getCompactFieldDisplayTitle(column, title, propertyName);
};
